import React, { useState } from "react";
import { Button, Modal, Form } from "semantic-ui-react";
import { useForm } from "../util/hooks";
import { useMutation } from "@apollo/react-hooks";
import { ADD_FARM_SYSTEM_PLAYER } from "../util/graphql";
// import { FETCH_TEAM_QUERY } from "../util/graphql";

function AddFarmModal(props) {
  const [open, setOpen] = React.useState(false);
  const [errors] = useState({});

  const { onChange, onSubmit, values } = useForm(addFarmSystemPlayerCallback, {
    name: "",
    pos: "",
    org: "",
    fv: "",
    fangraphs: "",
  });

  const [addFarmSystemPlayer] = useMutation(ADD_FARM_SYSTEM_PLAYER, {
    variables: values,
    update() {
      // const data = proxy.readQuery({
      //   query: FETCH_WATCH_TEAM_QUERY,
      // });
      // data.getWatchTeam = [result.data.addFarmSystemPlayer, ...data.getWatchTeam];
      // proxy.writeQuery({ query: FETCH_WATCH_TEAM_QUERY, data });
      values.name = "";
      values.pos = "";
      values.org = "";
      values.fv = "";
      values.fangraphs = "";
      window.location.reload(false);
    },
  });

  function addFarmSystemPlayerCallback() {
    addFarmSystemPlayer();
  }

  return (
    <Modal
      as={Form}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={
        <Button positive>
          Add Player
          {/* <Icon name="add" /> */}
        </Button>
      }
    >
      <Modal.Header>Add Player to Your Farm System</Modal.Header>
      <Modal.Content style={{ width: "75%" }}>
        <Form.Input
          label="Name"
          placeholder="Name.."
          name="name"
          type="text"
          value={values.name}
          error={errors.name ? true : false}
          onChange={onChange}
        />
        <Form.Input
          label="Position"
          placeholder="Position.."
          name="pos"
          type="pos"
          value={values.pos}
          error={errors.pos ? true : false}
          onChange={onChange}
        />
        <Form.Input
          label="Org"
          placeholder="Team.."
          name="org"
          type="org"
          value={values.org}
          error={errors.org ? true : false}
          onChange={onChange}
        />
        <Form.Input
          label="FV"
          placeholder="FV"
          name="fv"
          type="fv"
          value={values.fv}
          error={errors.fv ? true : false}
          onChange={onChange}
        />
        <Form.Input
          label="Fangraphs"
          placeholder="Fangraphs Link (Optional)"
          name="fangraphs"
          type="fangraphs"
          value={values.fangraphs}
          error={errors.fangraphs ? true : false}
          onChange={onChange}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)}>Cancel</Button>
        <Button type="submit" onClick={onSubmit} positive>
          Add
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default AddFarmModal;
